export default {
	getById(id, cb) {
		this.http.get(`/gift/getById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	search(params, cb) {
		this.http.get('/gift/search/', { params }).then((res) => {
			cb(res)
		})
	},
	searchLog(params, cb, ecb) {
		this.http
			.get('/gift/searchLog/', { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	statusLog(id, to, cb, ecb) {
		this.http
			.get(`/gift/logstatus/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(e, cb, ecb, config = {}) {
		this.http
			.post('/gift/update', e, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	confirmRedeem(id, form, cb, ecb, config = {}) {
		this.http
			.post(`/gift/confirmRedeem/${id}`, form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
